(function() {
    'use strict';

    var $blogCtn;

    function loadLastBlogs(index, ctn) {
        var cat = ctn.getAttribute("data-category");
        var wrap = ctn.querySelector(".blog-home-row");
        var settingsCount = ctn.getAttribute("data-count") ? ctn.getAttribute("data-count") : $(ctn).hasClass("ver1") ? 3 : 2;

        if (wrap.getAttribute("data-use-ajax")) {
            var data = [];

            data.push("count=" + (parseInt(settingsCount) + 3));

            if (cat !== "") {
                data.push("categoryId=" + cat);
            }

            ajax("/action/ajaxGetBlog?" + data.join("&"), function(res) {
                var o = JSON.parse(res);
                var count = o.blogs.length;
                var temp1 = wrap.querySelector(".one-suggested-blog.home") || wrap.querySelector(".one-suggested-blog");
                var temp2 = wrap.querySelector(".one-suggested-blog.column");
                var sideColumn = wrap.querySelector(".blog-home-column");

                if (sideColumn && count <= settingsCount) {
                    sideColumn.parentElement.removeChild(sideColumn);
                    sideColumn = null;
                }

                if (count) {
                    wrap.removeChild(wrap.querySelector(".no-blogs-message"));

                    for (var i = 0; i < count; i++) {
                        var ob = o.blogs[i];
                        var clone, html;

                        if (temp2 && i >= settingsCount) {
                            clone = temp2.cloneNode(true);
                            temp2.parentElement.appendChild(clone);
                        } else {
                            clone = temp1.cloneNode(true);
                            if (sideColumn) {
                                wrap.insertBefore(clone, sideColumn);
                            } else {
                                wrap.appendChild(clone);
                            }
                        }
                        html = clone.innerHTML;

                        for (var prop in ob) {
                            var re = new RegExp("\\[\\[" + prop + "\\]\\]", "g");
                            html = html.replace(re, ob[prop]);
                        }
                        clone.innerHTML = html;

                        if (ob.imagePath || !ob.mediaId || ob.mediaId === "0") {
                            var imgLink = clone.querySelector(".blog-img-link");
                            if (imgLink) {
                                imgLink.parentElement.removeChild(imgLink);
                            }
                        }
                        if (!ob.imagePath) {
                            var imgLink = clone.querySelector(".blog-img-path-link");
                            if (imgLink) {
                                imgLink.parentElement.removeChild(imgLink);
                            }
                        }
                        clone.querySelector(".suggested-blog-content").className += " no-padding";
                        if (!ob.author || ob.author === "") {
                            var author = clone.querySelector(".suggested-blog-author");
                            if (author) {
                                author.parentElement.removeChild(author);
                            }
                        }
                    }
                }

                wrap.style.display = "";
                if (temp1) {
                    temp1.parentElement.removeChild(temp1);
                }
                if (temp2) {
                    temp2.parentElement.removeChild(temp2);
                }
                if (count > 3) {
                    var t = $(wrap);

                    t.on('init', function(event, slick) {
                        adaptHeight(slick);
                    }).on('beforeChange', function(event, slick, currentSlide) {
                        adaptHeight(slick);
                    }).slick({
                        dots: false,
                        arrows: true,
                        prevArrow: t.find('.blog-slider-btn.prev'),
                        nextArrow: t.find('.blog-slider-btn.next'),
                        slide: '.one-suggested-blog',
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                }
                            },
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                }
                            }
                        ]
                    }).fadeIn();
                } else {
                    $(wrap).find('.blog-slider-btn').remove();
                }
            });
        }
    }
    
    function adaptHeight(slick) {
        setTimeout(function() {
            if (slick.$slideTrack.css('display') === 'flex') {
                slick.$list.css('height', '');
            } else {
                var h = 0;
                slick.$slides.filter('.slick-active').each(function() {
                    if (this.clientHeight > h) {
                        h = this.clientHeight;
                    }
                });
                slick.$list.css('height', (h + 20) + 'px');
            }
        }, 10);
    }

    /* INIT */
    $(window).ready(function() {
        
        $blogCtn = $(".blog-home-ctn");
        if ($blogCtn.length) {
            $blogCtn.each(loadLastBlogs);
        }
    });

})();

